module.exports = __webpack_public_path__ + "img/receipt26.99f9f14e.png";